import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import {
  AppImage,
  Container,
  FeatureDescription,
  FeatureDescriptionContainer,
  FeatureTitle,
  ImageContainer,
} from './AppFeature.styles'
interface IProps {
  title: string
  description: string
  imageUrl: string
  bgColor: string
  index: number
}

export default function AppFeature(props: IProps) {
  const { bgColor, description, imageUrl, title, index } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  function isReverseRow() {
    return index % 2 !== 0
  }

  return (
    <Container reverse={isReverseRow()}>
      <ImageContainer bgColor={bgColor}>
        <AppImage src={imageUrl} />
      </ImageContainer>
      <FeatureDescriptionContainer>
        <FeatureTitle>{t(title)}</FeatureTitle>
        <FeatureDescription>{t(description)}</FeatureDescription>
      </FeatureDescriptionContainer>
    </Container>
  )
}
